import classNames from 'classnames';
import { HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';
import { Button } from '../../Button';
import { IsVisible } from '../../utils';

type IFormActionsAlign = 'left' | 'center' | 'right';

interface IFormActionsProps extends HTMLAttributes<HTMLDivElement> {
  align?: IFormActionsAlign;
  badgeAmpunt?: number;
  cancelText?: string;
  disabled?: boolean;
  isSubmitting?: boolean;
  onClose?: () => void;
  onSubmit?: () => void;
  submitText?: string;
}

export function FormActions({
  align = 'right',
  badgeAmpunt,
  cancelText = 'Cancel',
  className,
  disabled = false,
  isSubmitting = false,
  onClose,
  onSubmit,
  submitText = 'Submit',
  ...rest
}: IFormActionsProps) {
  return (
    <div
      className={classNames(
        twMerge('flex items-center gap-x-2 mt-4', className),
        {
          'justify-end': align === 'right',
          'justify-center': align === 'center',
          'justify-start': align === 'left',
        },
      )}
      {...rest}
    >
      {onClose && (
        <Button
          className="relative text-secondary-two hover:opacity-60"
          design="outline"
          disabled={disabled || isSubmitting}
          onClick={onClose}
        >
          <IsVisible when={!!badgeAmpunt && badgeAmpunt > 0}>
            <div className="absolute -top-[10px] -right-[8px] flex items-center justify-center w-6 h-6 bg-gray-200 rounded-full text-red-500 text-xs font-semibold">
              {badgeAmpunt}
            </div>
          </IsVisible>
          {cancelText}
        </Button>
      )}
      <Button
        className="rounded px-6"
        design="secondary-dark"
        disabled={disabled || isSubmitting}
        isLoading={isSubmitting}
        onClick={onSubmit}
        type="submit"
      >
        {submitText}
      </Button>
    </div>
  );
}
